const quizData = [
  // --- LEVEL QUESTIONS (Q1 - Q10) ---
  {
    q: "WHAT DO YOU USUALLY REACH FOR FIRST IN THE MORNING?",
    options: [
      { text: "I go straight for coffee or tea", icon: "fa-mug-hot", score: 0 },
      { text: "I start with water", icon: "fa-glass-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Your body wakes up mildly dehydrated.</p><p class="text-white mt-2 mb-0 fs-5">Starting the day hydrated supports energy and focus.</p>`
  },
  {
    q: "HOW DOES HYDRATION USUALLY LOOK DURING YOUR WORKDAY?",
    options: [
      { text: "I realised I haven't drunk water in hours", icon: "fa-glass-water", score: 0 },
      { text: "I sip water throughout the day", icon: "fa-glass-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">It’s easy to lose track of hydration during busy days.</p><p class="text-white mt-2 mb-0 fs-5">Even mild dehydration can affect focus, energy, and productivity.</p>`
  },
  {
    q: "WHEN YOU'VE BEEN OUT IN THE HEAT, WHAT DO YOU USUALLY DO?",
    options: [
      { text: "I drink water once I start feeling thirsty", icon: "fa-glass-water", score: 0 },
      { text: "I drink water before going outdoors", icon: "fa-glass-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Thirst is often a late signal.</p><p class="text-white mt-2 mb-0 fs-5">Hydration isn’t just about drinking, it’s about how well your body absorbs fluids.</p>`
  },
  {
    q: "DURING LONG COMMUTES...",
    options: [
      { text: "I usually just drink when I get thirsty", icon: "fa-glass-water", score: 0 },
      { text: "I try to hydrate regularly during travel", icon: "fa-glass-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Travel environments such as air-conditioning and long commutes can increase fluid loss.</p>`
  },
  {
    q: "MID-AFTERNOON FATIGUE HITS",
    options: [
      { text: "Coffee to power through", icon: "fa-mug-hot", score: 0 },
      { text: "Hydrate first", icon: "fa-glass-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Fatigue can sometimes be a sign of dehydration.</p><p class="text-white mt-2 mb-0 fs-5">Hydrating first can help restore focus and energy during the day.</p>`
  },
  {
    q: "YOUR APPROACH TO YOUR HEALTH IS MORE ABOUT?",
    options: [
      { text: "Feeling good and staying balanced", icon: "fa-scale-balanced", score: 10 },
      { text: "Getting more out of yourself and pushing further", icon: "fa-arrow-trend-up", score: 10 }
    ],
    type: "level",
    // insight: `<p class="text-white mt-4 fs-5">Busy routines can make it easy to forget hydration.</p><p class="text-white mt-2 mb-0 fs-5">Building simple hydration habits throughout the day helps maintain daily wellness.</p>`
  },
  {
    q: "HOW DO YOU USUALLY KNOW YOU’RE DEHYDRATED?",
    options: [
      { text: "When I feel thirsty", icon: "fa-droplet-slash", score: 0 },
      { text: "When energy or performance drops", icon: "fa-battery-quarter", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Energy and focus drops are often the first real signs of dehydration — thirst comes later than most people think.</p>`
  },
  {
    q: "WHEN SOMETHING IN YOUR BODY FEELS OFF DURING THE DAY, YOU USUALLY?",
    options: [
      { text: "Take it easy and let it pass", icon: "fa-bed", score: 10 },
      { text: "Look for something to fix it and get back on track", icon: "fa-bolt", score: 10 }
    ],
    type: "level",
    // insight: `<p class="text-white mt-4 fs-5">How fast your body absorbs fluids depends on the drink’s balance of water and electrolytes.</p><p class="text-white mt-2 mb-0 fs-5">True Hydration™ is designed to help your body absorb fluids more efficiently.</p>`
  },
  {
    q: "AFTER A PHYSICALLY OR MENTALLY DEMANDING DAY, YOU USUALLY?",
    options: [
      { text: "Rest and let your body recover naturally", icon: "fa-spa", score: 0 },
      { text: "Actively support recovery — nutrition, hydration, routine", icon: "fa-bolt-lightning", score: 10 }
    ],
    type: "level",
    // insight: `<p class="text-white mt-4 fs-5">Electrolyte balance supports faster hydration recovery such as Cellular Hydration™.</p>`
  },
  {
    q: "DURING LONG PERIODS OF WORK OR SCREEN TIME...",
    options: [
      { text: "I usually only drink when I remember", icon: "fa-desktop", score: 0 },
      { text: "I keep water nearby and hydrate regularly", icon: "fa-bottle-water", score: 10 }
    ],
    type: "level",
    insight: `<p class="text-white mt-4 fs-5">Even mild dehydration can affect concentration and mental clarity.</p><p class="text-white mt-2 mb-0 fs-5">Hydrating regularly helps support focus throughout the day.</p>`
  },

  // --- PROFILE QUESTIONS (Q11 - Q15) ---
  {
    q: "YOUR TYPICAL WEEKDAY LOOKS MORE LIKE:",
    options: [
      { text: "Desk work, meetings, and screen time", icon: "fa-laptop" },
      { text: "Moving around frequently throughout the day", icon: "fa-person-walking" }
    ],
    type: "profile",
    // insight: `<p class="text-white mt-4 fs-5">Different lifestyles create different hydration demands.</p><p class="text-white mt-2 mb-0 fs-5">Long hours of focus and activity both increase fluid needs in different ways.</p>`
  },
  {
    q: "YOUR WEEKLY ROUTINE USUALLY INCLUDES:",
    options: [
      { text: "Wellness activities like walking, yoga, stretching or nothing", icon: "fa-person-walking" },
      { text: "More physical routines and high-energy days", icon: "fa-person-running" }
    ],
    type: "profile",
    // insight: `<p class="text-white mt-4 fs-5">Different activity intensities place different hydration demands on the body.</p>`
  },
  {
    q: "WHEN IT COMES TO IMPROVING YOUR LIFESTYLE, YOU USUALLY FOCUS ON:",
    options: [
      { text: "Maintaining balance and overall wellbeing", icon: "fa-scale-balanced" },
      { text: "Optimising performance and pushing limits", icon: "fa-arrow-trend-up" }
    ],
    type: "profile",
    // insight: `<p class="text-white mt-4 fs-5">Some people hydrate for general wellbeing, while others use hydration as part of performance optimisation.</p>`
  },
  {
    q: "WHEN YOUR WEEK HAS BEEN PARTICULARLY DEMANDING, YOU TEND TO?",
    options: [
      { text: "Slow down and give yourself space to recover", icon: "fa-bed" },
      { text: "Push through and find ways to bounce back faster", icon: "fa-spa" }
    ],
    type: "profile",
    // insight: `<p class="text-white mt-4 fs-5">Recovery is not only about rest.</p><p class="text-white mt-2 mb-0 fs-5">Rehydrating helps restore fluid balance and supports the body’s recovery after demanding days.</p>`
  },
  {
    q: "IN YOUR DAY-TO-DAY LIFE, PHYSICAL MOVEMENT IS?",
    options: [
      { text: "Something I do when I have time or feel like it", icon: "fa-battery-half" },
      { text: "A regular part of my routine I rarely skip", icon: "fa-battery-full" }
    ],
    type: "profile",
    // insight: `<p class="text-white mt-4 fs-5">Hydration levels can influence both physical endurance and mental performance.</p>`
  }
];

let currentQuestion = 0;
let score = 0;
let profileAnswers = [];
let questionHistory = [];
let autoCloseTimer;
let answeredIndices = [];

function nextSection(nextId) {
  const sections = document.querySelectorAll('.page-section');
  sections.forEach(sec => sec.classList.remove('active'));

  const target = document.getElementById(nextId);
  if (target) {
    target.classList.add('active');
    if (nextId === 'sec-profile') {
      document.body.classList.add('profile-active');
    } else {
      document.body.classList.remove('profile-active');
    }
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    setTimeout(() => {
      window.scrollTo(0, 0);
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;
    }, 50);
  }
}

function startQuiz() {
  currentQuestion = 0;
  score = 0;
  profileAnswers = [];
  questionHistory = [];
  answeredIndices = [];
  renderQuestion();
  nextSection('sec-quiz');
}

function renderQuestion() {
  const qData = quizData[currentQuestion];
  const resolveAsset = (name) => (window.shopifyAssets && window.shopifyAssets[name]) || name;

  // Update Question Number Label
  document.getElementById('quiz-progress-text').innerText = `QUESTION ${String(currentQuestion + 1).padStart(2, '0')}/15`;

  let questionHTML = qData.q;
  if (qData.insight) {
    const insightIconUrl = (window.shopifyAssets && window.shopifyAssets['insight-icon.png']) || 'insight-icon.png';
    questionHTML += `
            <span class="insight-icon" onclick="toggleTooltip(event)">
                <img src="${insightIconUrl}" alt="i" style="position: relative; z-index: 2; height: 65%; width: auto; object-fit: contain;">
                <div class="custom-tooltip" id="tooltip-${currentQuestion}">
                    ${qData.insight}
                </div>
            </span>
        `;
  }
  document.getElementById('quiz-question-title').innerHTML = questionHTML;

  // Update Progress Bar
  if (currentQuestion >= 0) {
    document.getElementById('quiz-mini-bar-container').style.display = 'inline-block';

    const fillEl = document.getElementById('quiz-mini-bar-fill');
    fillEl.style.width = `${((currentQuestion) / quizData.length) * 100}%`;

    // Reset color classes
    fillEl.classList.remove('fill-orange', 'fill-yellow', 'fill-blue', 'fill-green');

    if (score < 25) {
      fillEl.classList.add('fill-orange');
    } else if (score < 50) {
      fillEl.classList.add('fill-yellow');
    } else if (score < 75) {
      fillEl.classList.add('fill-blue');
    } else {
      fillEl.classList.add('fill-green');
    }

  } else {
    document.getElementById('quiz-mini-bar-container').style.display = 'none';
  }

  // Render Options
  const container = document.getElementById('quiz-options-container');
  container.innerHTML = "";
  qData.options.forEach((opt, index) => {
    const div = document.createElement('div');
    const isSelected = answeredIndices[currentQuestion] === index ? 'selected' : '';
    div.className = `quiz-option d-flex mb-4 ${isSelected}`;
    div.onclick = function () {
      selectDynOption(div, opt.score || 0, index);
    };
    const optionIndex = index + 1;
    div.innerHTML = `
            <div class="option-icon-wrap me-3">
                <img src="${resolveAsset(`icon-q${currentQuestion + 1}-${optionIndex}.png`)}" alt="${opt.icon}">
            </div>
            <div class="option-label fw-bold">
                ${opt.text}
            </div>
        `;
    container.appendChild(div);
  });


}

function selectDynOption(element, earnedScore, optionIndex) {
  const parent = element.parentElement;
  parent.querySelectorAll('.quiz-option').forEach(opt => opt.classList.remove('selected'));
  element.classList.add('selected');

  answeredIndices[currentQuestion] = optionIndex;

  questionHistory.push({
    score: score,
    profileAnswers: [...profileAnswers]
  });

  if (quizData[currentQuestion].type === 'level') {
    score += earnedScore;
  } else if (quizData[currentQuestion].type === 'profile') {
    profileAnswers.push(optionIndex);
  }

  const isLastQuestion = currentQuestion === quizData.length - 1;

  if (isLastQuestion) {
    // 1. Update progress bar immediately
    const fillEl = document.getElementById('quiz-mini-bar-fill');
    if (fillEl) fillEl.style.width = '100%';

    // 2. Wait 3 seconds for the user to admire their completion
    setTimeout(() => {
      const quizCard = document.getElementById('quiz-card');
      if (quizCard) quizCard.classList.add('fade-out');

      // 3. Wait exactly 300ms for the smooth fade-out animation to finish
      setTimeout(() => {
        advanceQuiz(); // Switches to profile page view

        if (quizCard) {
          quizCard.classList.remove('fade-out');
          quizCard.classList.add('fade-in');
          // 4. Wait 350ms for fade-in to finish, then clean up the class
          setTimeout(() => quizCard.classList.remove('fade-in'), 350);
        }
      }, 300);
    }, 2000);

  } else {
    // Standard question progression (300ms delay to let user see what they clicked)
    setTimeout(() => {
      const quizCard = document.getElementById('quiz-card');
      if (quizCard) quizCard.classList.add('fade-out');

      // Wait exactly 300ms for fade-out to finish before changing the question content
      setTimeout(() => {
        advanceQuiz();

        if (quizCard) {
          quizCard.classList.remove('fade-out');
          quizCard.classList.add('fade-in');
          // Wait exactly 350ms for fade-in to finish before cleaning up
          setTimeout(() => quizCard.classList.remove('fade-in'), 350);
        }
      }, 300);
    }, 300);
  }
}

function prevQuestion() {
  if (currentQuestion > 0) {
    const prevState = questionHistory.pop();
    if (prevState) {
      score = prevState.score;
      profileAnswers = prevState.profileAnswers;
      currentQuestion--;

      const quizCard = document.getElementById('quiz-card');
      if (quizCard) {
        quizCard.classList.add('fade-out');
        // Smoothly wait out the transition duration
        setTimeout(() => {
          renderQuestion();
          quizCard.classList.remove('fade-out');
          quizCard.classList.add('fade-in');
          setTimeout(() => quizCard.classList.remove('fade-in'), 350);
        }, 300);
      } else {
        renderQuestion();
      }
    }
  } else {
    nextSection('sec-adds-up');
  }
}

function advanceQuiz() {
  currentQuestion++;
  if (currentQuestion < quizData.length) {
    renderQuestion();
  } else {
    showProfile();
  }
}

function toggleTooltip(event) {
  event.stopPropagation();
  const tooltip = event.currentTarget.querySelector('.custom-tooltip');
  if (tooltip) {
    tooltip.classList.toggle('active');
  }
}

// Close tooltips when clicking anywhere else
document.addEventListener('click', () => {
  document.querySelectorAll('.custom-tooltip').forEach(tt => tt.classList.remove('active'));
});

// ---- Profiles Data ----
const profilesData = {
  'DAILY ATHLETE': {
    intro: "Your active routine increases your hydration demands",
    traits: ["Show up daily", "Moves with purpose", "Energy in motion", "Makes time to train", "Motivated"],
    plan: {
      morning: {
        header: "Ease Into Your Day",
        sub: "Start your day with a quick boost to stay ahead of fluid loss.",
        goto: "cellular.png",
        alsotry: "coconut.png",
        alsotryText: "Coconut water"
      },
      evening: {
        header: "End Of Day Reset",
        sub: "Rehydrate steadily after workouts or long active days to maintain balance.",
        goto: "true-hydration.png",
        alsotry: "watermelon-juice.png",
        alsotryText: "Watermelon juice"
      }
    },
    icon: 'daily-athlete.png'
  },
  'WELLNESS SEEKER': {
    intro: "Your routine is centred on balance and recovery",
    traits: ["Calm and mindful", "Prioritises balance", "Restorative habits", "Chooses consciously", "Stay grounded"],
    plan: {
      morning: {
        header: "Ease Into Your Mornings",
        sub: "Ease into your day with gentle hydration to feel refreshed.",
        goto: "cellular.png",
        alsotry: "fruit-infused-water.png",
        alsotryText: "Fruit infused water"
      },
      evening: {
        header: "Stay Steady Through The Day",
        sub: "Keep hydration consistent through your routine to maintain balance.",
        goto: "true-hydration.png",
        alsotry: "coconut.png",
        alsotryText: "Coconut water"
      }
    },
    icon: 'wellness-seeker.png'
  },
  'PERFORMANCE OPTIMISER': {
    intro: "You focus on efficiency, performance, and staying sharp",
    traits: ["Performance driven", "Disciplined", "Strategic choices", "Moving in-between", "Stays prepared"],
    plan: {
      morning: {
        header: "Start Ready, Stay Ahead",
        sub: "Kickstart your day with hydration to stay elevated and prepared.",
        goto: "cellular.png",
        alsotry: "smoothie.png",
        alsotryText: "Smoothie"
      },
      evening: {
        header: "Recover Right, Perform Better",
        sub: "Rehydrate after your day to reset and maintain peak performance.",
        goto: "true-hydration.png",
        alsotry: "three-glasses-water.png",
        alsotryText: "3 glass of water"
      }
    },
    icon: 'performance-optimiser.png'
  },
  'ACTIVE PROFESSIONALS': {
    intro: "Your days are packed, and you’re always moving",
    traits: ["Multi-tasker", "Stay responsive", "Get things done", "Juggles work and life", "Handles packed days"],
    plan: {
      morning: {
        header: "Start Clear, Stay Focused",
        sub: "Kickstart your morning with quick hydration before your schedule fills up.",
        goto: "cellular.png",
        alsotry: "fruit-juice.png",
        alsotryText: "Fruit juice"
      },
      evening: {
        header: "Keep Going Through The Day",
        sub: "Stay hydrated to feel composed and sharp throughout the day.",
        goto: "true-hydration.png",
        alsotry: "coconut.png",
        alsotryText: "Coconut water"
      }
    },
    icon: 'active-professionals.png'
  }
};

const footerColors = {
  'WELLNESS SEEKER': 'rgba(207, 137, 214, 1)',
  'ACTIVE PROFESSIONALS': 'rgba(36, 135, 148, 1)',
  'DAILY ATHLETE': 'rgba(0, 0, 153, 1)',
  'PERFORMANCE OPTIMISER': 'rgba(255, 182, 0, 1)'
};

const liquidColors = {
  'WELLNESS SEEKER': 'rgba(221, 195, 208, 1)',
  'ACTIVE PROFESSIONALS': 'rgba(150, 203, 223, 1)',
  'DAILY ATHLETE': 'rgba(26, 169, 254, 1)',
  'PERFORMANCE OPTIMISER': 'rgba(254, 216, 128, 1)'
};

function showProfile(forcedProfile = null, forcedScore = null) {
  let finalProfile = "WELLNESS SEEKER"; // default

  if (forcedProfile) {
    finalProfile = forcedProfile;

    // Sesuaikan score berdasarkan parameter atau profile
    if (forcedScore !== null && !isNaN(forcedScore)) {
      score = forcedScore;
    } else if (forcedProfile === "PERFORMANCE OPTIMISER") {
      score = 100;
    } else if (forcedProfile === "DAILY ATHLETE" || forcedProfile === "WELLNESS SEEKER") {
      score = 80;
    } else if (forcedProfile === "ACTIVE PROFESSIONALS") {
      score = 50;
    } else {
      score = 0;
    }
  } else {
    // Determine Final Profile (Indices 0/1 refer to Left/Right options)
    const q11 = profileAnswers[0] || 0;
    const q12 = profileAnswers[1] || 0;
    const q13 = profileAnswers[2] || 0;

    if (q11 === 0 && q12 === 0 && q13 === 0) { finalProfile = "WELLNESS SEEKER"; }
    else if (q11 === 0 && q12 === 0 && q13 === 1) { finalProfile = "ACTIVE PROFESSIONALS"; }
    else if (q11 === 0 && q12 === 1 && q13 === 1) { finalProfile = "ACTIVE PROFESSIONALS"; }
    else if (q11 === 1 && q12 === 1 && q13 === 0) { finalProfile = "DAILY ATHLETE"; }
    else if (q11 === 1 && q12 === 1 && q13 === 1) { finalProfile = "PERFORMANCE OPTIMISER"; }
    else { finalProfile = q11 === 0 ? "ACTIVE PROFESSIONALS" : "DAILY ATHLETE"; }
  }

  // Tampilkan level panel karena score sudah diset
  const levelPanel = document.querySelector('#sec-profile .profile-level-panel');
  if (levelPanel) levelPanel.style.display = 'flex';

  let label = "YOU MIGHT BE DEHYDRATED";
  let desc = "You’re likely hydrating too late or not enough throughout the day.";
  let dotClass = "orange";

  if (score >= 40 && score <= 60) {
    label = "YOUR BODY NEEDS HYDRATION SUPPORT";
    desc = "Your body could use more consistent or timely hydration.";
    dotClass = "yellow";
  }
  if (score >= 70 && score <= 90) {
    label = "YOU'RE DOING PRETTY WELL";
    desc = "You’re doing well overall, but your hydration dips at key points in the day.";
    dotClass = "light-green";
  }
  if (score === 100) {
    label = "YOU'RE ON TRACK";
    desc = "You stay consistent and hydrated throughout your day.";
    dotClass = "teal";
  }

  const resolveAsset = (name) => (window.shopifyAssets && window.shopifyAssets[name]) || name;

  const titleEl = document.getElementById('profile-level-title');
  if (titleEl) titleEl.innerText = label;

  const descEl = document.getElementById('profile-level-desc');
  if (descEl) descEl.innerText = desc;

  const dot = document.getElementById('profile-level');
  if (dot) dot.src = resolveAsset(`truth-${dotClass}.png`);

  const pData = profilesData[finalProfile];

  // Update Profile Reveal Section
  const resultTitleEl = document.getElementById('profile-result-title');

  const resultDescEl = document.getElementById('profile-result-desc');
  if (resultDescEl) resultDescEl.innerText = pData.intro;

  const iconEl = document.getElementById('profile-result-icon');
  if (iconEl) {
    const bgKey = `bg-${pData.icon}`;
    resultTitleEl.src = resolveAsset(`pname-${pData.icon}`);

    const ribbonBlues = document.querySelectorAll('#sec-profile .ribbon-blue, #journey-popup-overlay .ribbon-blue');
    ribbonBlues.forEach(el => {
      el.style.backgroundImage = `url(${resolveAsset(bgKey)})`;
    });

    const footerColor = footerColors[finalProfile];
    const footerBar = document.querySelector('#footer-bar');
    if (footerBar) footerBar.style.background = footerColor;

    const liquidColor = liquidColors[finalProfile];
    const fluidBG = document.querySelector('.fluid-bg');
    console.log(fluidBG);
    const bg1 = liquidColor;
    const bg50 = liquidColor.replace('1)', '0.5)');
    if (fluidBG) fluidBG.style.background = `radial-gradient(at 0% 100%, ${bg1} 0px, transparent 80%), radial-gradient(at 100% 0%, ${bg50} 0px, transparent 100%)`;

    const popupContent = document.querySelector('.journey-popup-content');
    if (popupContent) {
      popupContent.style.background = `radial-gradient(at 0% 100%, ${bg1} 0px, transparent 80%), radial-gradient(at 100% 0%, ${bg50} 0px, transparent 100%), rgba(255, 255, 255, 0.6)`;
    }

    iconEl.src = resolveAsset(pData.icon);
    iconEl.style.display = 'block';
    document.getElementById("profile-plan").src = resolveAsset("plan-" + pData.icon);
    if (iconEl.nextElementSibling) iconEl.nextElementSibling.style.display = 'none';

    const profileDetails = document.getElementById("profile-details");
    profileDetails.src = resolveAsset("profile-" + pData.icon);

    if (finalProfile == 'ACTIVE PROFESSIONALS') {
      resultTitleEl.style.fontSize = '3.5em';
    }

    if (finalProfile == 'PERFORMANCE OPTIMISER') {
      resultTitleEl.style.fontSize = '3.2em';
      resultTitleEl.style.setProperty('color', 'var(--font-blue)', 'important');
      const ribbonBlues = document.querySelectorAll('#sec-profile .ribbon-blue, #footer-bar h5, #footer-bar i, #journey-popup-overlay .ribbon-blue');
      ribbonBlues.forEach(el => {
        el.style.setProperty('color', 'var(--font-blue)', 'important');
      });

      const circles = document.querySelectorAll('#footer-bar a');
      circles.forEach(el => {
        el.style.setProperty('color', 'var(--font-blue)', 'important');
        el.style.setProperty('border-color', 'var(--font-blue)', 'important');
      });
    }
  }

  // Update Traits
  const traitsList = document.getElementById('profile-traits-list');
  if (traitsList) {
    traitsList.innerHTML = pData.traits.map(t => `<li class="glass-panel text-center mb-2 p-2 fw-extra-bold">${t}</li>`).join('');
  }

  // Update Hydration Plan
  const planTitleEl = document.getElementById('plan-profile-title');
  if (planTitleEl) planTitleEl.innerText = finalProfile;

  // Morning Plan
  const planMorningHeader = document.getElementById('plan-morning-header');
  if (planMorningHeader) planMorningHeader.innerText = pData.plan.morning.header;
  const planMorningSub = document.getElementById('plan-morning-sub');
  if (planMorningSub) planMorningSub.innerText = pData.plan.morning.sub;
  const planMorningGoto = document.getElementById('plan-morning-goto');
  if (planMorningGoto) planMorningGoto.src = resolveAsset(pData.plan.morning.goto);
  const planMorningAlsoTryImg = document.getElementById('plan-morning-alsotry-img');
  if (planMorningAlsoTryImg) planMorningAlsoTryImg.src = resolveAsset(pData.plan.morning.alsotry);
  const planMorningAlsoTryText = document.getElementById('plan-morning-alsotry-text');
  if (planMorningAlsoTryText) planMorningAlsoTryText.innerText = pData.plan.morning.alsotryText;

  // Evening Plan
  const planEveningHeader = document.getElementById('plan-evening-header');
  if (planEveningHeader) planEveningHeader.innerText = pData.plan.evening.header;
  const planEveningSub = document.getElementById('plan-evening-sub');
  if (planEveningSub) planEveningSub.innerText = pData.plan.evening.sub;
  const planEveningGoto = document.getElementById('plan-evening-goto');
  if (planEveningGoto) planEveningGoto.src = resolveAsset(pData.plan.evening.goto);
  const planEveningAlsoTryImg = document.getElementById('plan-evening-alsotry-img');
  if (planEveningAlsoTryImg) planEveningAlsoTryImg.src = resolveAsset(pData.plan.evening.alsotry);
  const planEveningAlsoTryText = document.getElementById('plan-evening-alsotry-text');
  if (planEveningAlsoTryText) planEveningAlsoTryText.innerText = pData.plan.evening.alsotryText;

  const shareTitleEl = document.getElementById('share-profile-title');
  if (shareTitleEl) shareTitleEl.innerText = finalProfile;

  // Save current profile for sharing URL
  window._currentSharedProfile = finalProfile;
  window._currentSharedScore = score;

  // Keep the latest completed result available for this browser session.
  try {
    sessionStorage.setItem('hydrationQuizResult', JSON.stringify({
      profile: finalProfile,
      score: score
    }));
  } catch (error) {
    // Continue normally when session storage is unavailable.
  }
  // Mark a completed quiz in the URL without reloading the profile page.
  const resultUrl = new URL(window.location.href);
  resultUrl.searchParams.set('q', 'success');
  window.history.replaceState({}, '', resultUrl);

  nextSection('sec-profile');
  document.documentElement.classList.add('profile-loaded');
  updateFacebookShareLink();

  // Show journey popup after 8 seconds
  setTimeout(() => {
    const popup = document.getElementById('journey-popup-overlay');
    if (popup) {
      popup.classList.add('show');
    }
  }, 8000);
}

function showJourneyPopup() {
  const popup = document.getElementById('journey-popup-overlay');
  if (popup) {
    popup.classList.add('show');
  }
}

function closeJourneyPopup() {
  const popup = document.getElementById('journey-popup-overlay');
  if (popup) {
    popup.classList.remove('show');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const urlParams = new URLSearchParams(window.location.search);
  let profileParam = urlParams.get('profile');

  if (!profileParam) {
    const pathParts = window.location.pathname.split('/');
    const lastPart = pathParts[pathParts.length - 1];
    if (lastPart && lastPart.startsWith('profile-')) {
      profileParam = lastPart.replace('profile-', '');
    }
  }

  const showHome = () => {
    const homeSec = document.getElementById('sec-home');
    if (homeSec) {
      nextSection('sec-home');
    } else {
      const profileSec = document.getElementById('sec-profile');
      if (profileSec) profileSec.classList.add('active');
    }
  };

  if (profileParam) {
    const profileMap = {
      'daily-athlete': 'DAILY ATHLETE',
      'wellness-seeker': 'WELLNESS SEEKER',
      'performance-optimiser': 'PERFORMANCE OPTIMISER',
      'active-professionals': 'ACTIVE PROFESSIONALS'
    };
    const mappedProfile = profileMap[profileParam.toLowerCase()];
    const scoreParam = urlParams.get('score');
    const forcedScore = scoreParam !== null ? Number(scoreParam) : null;

    if (mappedProfile) {
      showProfile(mappedProfile, Number.isFinite(forcedScore) ? forcedScore : null);
    } else {
      showHome();
    }
    return;
  }

  if (urlParams.get('q') === 'success') {
    try {
      const savedResult = JSON.parse(sessionStorage.getItem('hydrationQuizResult'));
      if (savedResult && profilesData[savedResult.profile] && Number.isFinite(savedResult.score)) {
        showProfile(savedResult.profile, savedResult.score);
        return;
      }
    } catch (error) {
      // Fall through to the home page if session storage is unavailable or invalid.
    }
  }

  showHome();
});

function _buildShareUrl() {
  const profileSlug = (window._currentSharedProfile || '')
    .toLowerCase().replace(/ /g, '-');
  return window.location.origin + '/pages/profile-' + encodeURIComponent(profileSlug);
}

// function shareToFacebook() {
//   const url = _buildShareUrl();
//   window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
// }

function handleFacebookClick(e) {
  const url = _buildShareUrl();
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;

  if (isIOS && navigator.share) {
    e.preventDefault();
    navigator.share({
      title: 'Share Profile',
      url: url
    }).catch(console.error);
  }
}

function updateFacebookShareLink() {
  const url = _buildShareUrl();
  const fbBase = 'https://www.facebook.com/sharer/sharer.php?u=';
  const finalUrl = fbBase + encodeURIComponent(url);

  const btn = document.querySelector('.facebook-share-button');

  if (btn) {
    // 2. Set href for fallback
    btn.href = finalUrl;

    // 3. Remove existing listener before adding the new one
    btn.removeEventListener('click', handleFacebookClick);
    
    // 4. Add the handler
    btn.addEventListener('click', handleFacebookClick);
  }
}

function shareToInstagram() {
  const resolveAsset = (name) => (window.shopifyAssets && window.shopifyAssets[name]) || name;
  const profileSlug = (window._currentSharedProfile || 'wellness-seeker').toLowerCase().replace(/ /g, '-');
  let imageUrl = resolveAsset(`sharing-${profileSlug}.jpg`);

  if (imageUrl.startsWith('//')) {
    imageUrl = 'https:' + imageUrl;
  }

  fetch(imageUrl)
    .then(res => {
      if (!res.ok) throw new Error('Network response was not ok');
      return res.blob();
    })
    .then(blob => {
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `hydration-profile-${profileSlug}.jpg`;
      let profileName = profileSlug.replace('-', ' ');
      profileName = profileName.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      setTimeout(() => {
        alert(`Image downloaded! "${profileName}"\n\n1. Open Instagram\n2. Tap Story\n3. Upload the image`);
      }, 300);
    })
    .catch((err) => {
      console.error('Fetch failed:', err);
      alert('Automatic download blocked by browser. Opening image in a new tab so you can save it manually! 📸');
      window.open(imageUrl, '_blank');
    });
}

function shareToWhatsApp() {
  const url = _buildShareUrl();
  const profileLabel = (window._currentSharedProfile || 'Daily Athlete').toLowerCase().replace(/(^\w|\s\w)/g, m => m.toUpperCase());
  const firstLetter = profileLabel.charAt(0).toLowerCase();
  const vowels = ['a', 'e', 'i', 'o', 'u'];
  const result = vowels.includes(firstLetter) ? "I'm an " + profileLabel : "I'm a " + profileLabel;
  const text = `${result}! Find out your hydration profile: ${url}`;
  window.open('https://wa.me/?text=' + encodeURIComponent(text), '_blank');
}